<div class="container" id="main-content" aria-label="Main Content">

    <div>
        <h1 tabindex="0" class="heading-title">{{'TNCS.TITLE' | translate}}</h1>
        <hr />
    </div>

    <div class="row">
        <div class="col-md-8">
            <div class="card">
                <div class="card-body">
                    <div class="form-row">
                        <div *ngIf="globals.blLanguage == 0" tabindex="0" (click)="linkClicked($event)"
                            (keypress)="linkClicked($event)" [innerHTML]="tncsText | noSanitise"></div>
                        <div *ngIf="globals.blLanguage == 1" tabindex="0" (click)="linkClicked($event)"
                            (keypress)="linkClicked($event)" [innerHTML]="tncsTextIrish | noSanitise">
                        </div>
                    </div>

                    <div class="form-row" #error>
                        <form [formGroup]="tncForm">
                            <label><input type="checkbox" formControlName="tncCB" class="mr-2"
                                    tabindex="0">{{'TNCS.CHECKLIST_CONFIRM' | translate}}</label>
                            <div *ngIf="submitted && form.tncCB.errors">
                                <div style="color: red; padding-top: 0.2rem" *ngIf="form.tncCB.errors.required"
                                    role="alert" tabindex="0">
                                    {{'TNCS.CHECKLIST_VALIDATION' | translate}}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <mat-card>
                <app-booking-summary-card></app-booking-summary-card>
            </mat-card>
        </div>

    </div>

    <div class="row">
        <br />
    </div>

    <p class="alert-warning" tabindex="0">{{'TNCS.FINAL_CHECK_CONFIRMATION' | translate}}</p>

    <p *ngIf="slotsInPast" class="alert-danger">{{'APPLICATION_DETAILS.INVALID_SLOTS' | translate}}</p>

    <div *ngIf="slotsInvalid" class="mb-4">
        <div class="alert-danger">
            <span class="validation-msg"
                [innerHTML]="'APPLICATION_DETAILS.INVALID_SLOTS_SELECTED' | translate | noSanitise"></span>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <button class="btn btn-primary" (click)="routerGoBack()">{{'COMMON.BACK' | translate}}</button>
        </div>
        <div class="col-6 text-right">
            <button class="btn btn-primary" (click)="proceed()">{{'COMMON.PROCEED' | translate}}</button>
        </div>
        <button #paymentButton id="redirectPaymentID" class="hidden" (click)="proceed()">{{'COMMON.PROCEED' |
            translate}}</button>
    </div>
</div>